import { Box } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import React from 'react'
import Scanner_black from '../../assets/Scanner_black.svg'
import { Link } from 'react-router-dom';


const ManageDevices = () => {
  
  return (
    
      <div style={{ minHeight: "65vh", margin: "0 auto" }}>
      <Link to="/devicelist" style={{color:"black",textDecoration: 'none'}} onMouseEnter={(e) => { e.target.style.textDecoration = 'underline'; }} onMouseLeave={(e) => { e.target.style.textDecoration = 'none'; }}><h1
            style={{ fontWeight: "700", fontSize: "48px", marginTop: 10,color:'black' }}
            className="sasp_vz-nhg-eds-font"
          >
            DEVICES
          </h1></Link>
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
          <h1
            style={{ fontWeight: "400", fontSize: "24px", marginTop: 10,color:'black' }}
            className="sasp_vz-nhg-eds-font"
          >
            MANAGE DEVICES
          </h1>
        </div>
        <Grid2 container xs={12} direction="row">
            <Box sx={{ fontSize: "19Px" ,padding:1,borderRadius:2, backgroundColor:'#A7A7A7',width:'100%'}}>
              <span style={{paddingLeft:'8px'}}>SCAN DEVICE QR CODE</span>
              <div style={{marginTop:8,paddingLeft:'8px'}}>
                <p style={{fontSize:'16px'}}>Locate the QR on the top of the tag or on the back of the gateway and scan it with a handheld scanner attached to this computer.</p>
              </div>
            </Box>
        </Grid2>
      </div>
   
  );
};

export default ManageDevices;
